module.exports = __webpack_public_path__ + "static/media/banner.2c76ceb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/banner.png
// module id = 223
// module chunks = 0